"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalShare = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const ModalShare_style_1 = require("./ModalShare.style");
const SIZE_ICON = 24;
const ModalShare = ({ url, isOpen, message = '', onOpenChange, titleModal, }) => {
    const handleGoShareUrl = (url) => window.open(url, '_blank', 'noopener noreferrer');
    const shareFacebook = () => {
        const facebookMessage = encodeURIComponent(message.replace('###UTM###', 'utm_source=fb'));
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(url)}&quote=${facebookMessage}`;
        handleGoShareUrl(facebookUrl);
    };
    const shareWhatsapp = () => {
        const whatsappMessage = encodeURIComponent(message.replace('###UTM###', 'utm_source=wpp'));
        const whatsappUrl = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
        handleGoShareUrl(whatsappUrl);
    };
    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(url);
        flora_react_1.Toaster.notify({
            kind: 'success',
            origin: 'center-top',
            description: 'Link copiado com sucesso!',
        });
    };
    const ITEMS = [
        {
            icon: ((0, jsx_runtime_1.jsx)(flora_react_icons_1.SocialFacebookBoxIcon, { size: SIZE_ICON, color: "$nonInteractiveAltPredominant" })),
            label: 'Facebook',
            type: 'facebook',
            ariaLabel: 'Compartilhe no Facebook',
            action: shareFacebook,
        },
        {
            icon: ((0, jsx_runtime_1.jsx)(flora_react_icons_1.SocialWhatsappIcon, { size: SIZE_ICON, color: "$nonInteractiveAltPredominant" })),
            label: 'WhatsApp',
            type: 'whatsapp',
            ariaLabel: 'Compartilhe no WhatsApp',
            action: shareWhatsapp,
        },
        {
            icon: ((0, jsx_runtime_1.jsx)(flora_react_icons_1.TwoPiledSquaresIcon, { size: SIZE_ICON, color: "$nonInteractiveAltPredominant" })),
            label: 'Copiar Link',
            type: 'copy',
            ariaLabel: 'Copie a link na área de transferência',
            action: copyLinkToClipboard,
        },
    ];
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Modal, Object.assign({ open: isOpen, onOpenChange: onOpenChange }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.ModalContent, Object.assign({ size: "small", css: {
                width: '100%',
            } }, { children: [(0, jsx_runtime_1.jsxs)(ModalShare_style_1.ModalShareHeader, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyMediumShort" }, { children: titleModal || 'Compartilhar' })), (0, jsx_runtime_1.jsx)(ModalShare_style_1.ModalShareClose, {})] }), (0, jsx_runtime_1.jsx)(flora_react_1.ModalBody, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Flex, { children: ITEMS.map((item) => ((0, jsx_runtime_1.jsxs)(ModalShare_style_1.ButtonAction, Object.assign({ type: item.type, onClick: item.action, variant: "unstyled", "autotagging-flora": "on", "aria-label": item.ariaLabel }, { children: [(0, jsx_runtime_1.jsx)("i", { children: item.icon }), (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "exceptionsAuxiliarRegular" }, { children: item.label }))] }), item.label))) }) })] })) })));
};
exports.ModalShare = ModalShare;
